module.exports = __webpack_public_path__ + "static/media/about us.54c37939.png";